const BgAnimation = () => {
  return <></>;
};

export default BgAnimation;
